module.exports = __webpack_public_path__ + "images/category_lp/watch/reason1_9e6cfd49394c0371fc57a8eeb126011c.png";